import { Button, ButtonGroup, Popover, Position, Tag } from "@blueprintjs/core"
import { useRef, useState } from "react"
import useClickOutside from "src/libs/hooks/useClickOutside"
import { WINDOW_ICON, WINDOW_WIDTH } from "src/libs/interfaces/layouts" 
import { __ } from "src/libs/utilities"
import { ILandingConsoleStore, useLandingConsoleStore } from "src/modules/pe-landing-module/data/store"

/* Protopia Ecosystem component */
export interface IDisplaySizeNavigatorProps {
   isPosition?:boolean
}
const DisplaySizeNavigator = (props: IDisplaySizeNavigatorProps): JSX.Element => {
    const ref = useRef(null)
    useClickOutside( ref, () => setIsOpen(false) )
    const [isOpen, setIsOpen]  = useState<boolean>(false)
    const currentDimensionEdit = useLandingConsoleStore((state: ILandingConsoleStore) => state.currentDimensionEdit)
    const setDimension = (sz: keyof typeof WINDOW_ICON ) => { 
        setIsOpen(!isOpen)
        useLandingConsoleStore.setState({ currentDimensionEdit: WINDOW_WIDTH[sz] })
    }
    
    (Object.keys(WINDOW_WIDTH) as (keyof typeof WINDOW_ICON)[]).find(key => { 
        return WINDOW_WIDTH[key] === currentDimensionEdit
    } ) as keyof typeof WINDOW_ICON 
    
    return <div className='pe-display-size-navigator'>        
        <Popover
            position={Position.BOTTOM_RIGHT} 
            isOpen={isOpen}
            popoverClassName="z-index-100"
            modifiers={{ 
                arrow: { enabled: false },
                flip: { enabled: props.isPosition },
                preventOverflow: { enabled: false },
                offset: { 
                    enabled: true, 
                    options: {
                        offset: [ props.isPosition ? 150 : undefined, 4],
                    } 
                }, 
            }}
            content={
                <ButtonGroup vertical ref={ref}>
                {
                    (Object.keys(WINDOW_WIDTH) as (keyof typeof WINDOW_ICON)[])
                        .filter((sz: keyof typeof WINDOW_ICON ) => {
                            return !!WINDOW_ICON[ sz  ]
                        })
                        .map((sz: keyof typeof WINDOW_ICON, i ) => {
                            const icon = WINDOW_ICON[ sz  ]
                            return <Button key={ sz } alignText="left" className={ `${ currentDimensionEdit !== sz ? "opacity_5" : "" } p-3` } variant="minimal" onClick={() => setDimension(sz)}>
                                <div className="d-flex align-items-center w-100">
                                    <img
                                        src={ icon }
                                        className="svg-force-contrast"
                                        alt="" 
                                        height={ 22 }
                                    />
                                    <div>
                                        <div className="px-2 small title">{ __( sz ) }</div>
                                        <div className="px-2 small letter-spacing-1">{ WINDOW_WIDTH[ sz ] + "px"}</div>
                                    </div>
                                    <Tag minimal className="ml-2 px-2 py-0 ml-auto">
                                        <div className="smallest title">
                                            CTRL + { i }
                                        </div>
                                    </Tag>
                                </div>
                            </Button>
                        })
                }
                </ButtonGroup>
            }
        >
            <Popover
                modifiers={{ 
                    arrow: { enabled: false },
                    flip: { enabled: true },
                    preventOverflow: { enabled: false },
                    offset: { enabled: true, options: {
                        offset: [ 3, 4],
                    } }, 
                }}
                position={Position.BOTTOM_LEFT}
                interactionKind="hover"
                popoverClassName="z-index-100"
                content={
                    <div className="small px-2 py-1">
                        { currentDimensionEdit + "px"} 
                    </div>
                }
            >
                <Button onClick={() => setIsOpen(!isOpen)}>
                    <img
                        src={ 
                            WINDOW_ICON[ 
                                (Object.keys(WINDOW_WIDTH) as (keyof typeof WINDOW_ICON)[])
                                    .find(key => WINDOW_WIDTH[key] === currentDimensionEdit) as keyof typeof WINDOW_ICON
                            ] 
                        }
                        className="svg-force-contrast"
                        alt="" 
                        height={ 18 }
                    /> 
                </Button>  
            </Popover>
       </Popover>
    </div>
}
export default DisplaySizeNavigator